export const locale = {
  lang: 'en-CA',
  data: {
    DOCUMENTATION: {
      TITLE: 'Knowledge base',
    },
  },
};
